import { render, staticRenderFns } from "./NoBattle.vue?vue&type=template&id=4f551708&"
import script from "./NoBattle.vue?vue&type=script&lang=js&"
export * from "./NoBattle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports